import { env } from 'env';

const { REACT_APP_CLIENT_ENV } = env;

export const REACTIONS =
  REACT_APP_CLIENT_ENV === 'EK'
    ? ['waving2', 'thumbsdown', 'agreeing', 'clap', 'cooldance', 'raisehand']
    : ['waving', 'clap', 'agreeing', 'victory', 'waving2', 'cooldance'];
